import React from "react";
import { Box } from "@mui/material";
import { getSkillBadgeColorSet } from "../../../../constants/colors";

/**
 * スキル名を小さなバッジ（タグ）として表示するためのコンポーネント
 */
const IndexCardSkillBadge = ({ type, label, isNew }) => {
  // job → 青, project → 紫
  const colors = getSkillBadgeColorSet(type);

  return (
    <Box
      sx={{
        backgroundColor: isNew ? colors.bgStrong : colors.bgDefault,
        color: isNew ? colors.textStrong : colors.textDefault,
        border: isNew ? "none" : colors.border,
        px: 1,
        py: 0.3,
        borderRadius: 16,
        fontSize: { xs: "0.6rem", sm: "0.65rem" },
        fontWeight: 600,
        display: "inline-block",
      }}
    >
      {label}
    </Box>
  );
};

export default IndexCardSkillBadge;
